import { regularWhite, fontWeightBold } from 'app/ui-components/design-tokens';
import styled, { css } from 'styled-components';
import { playFontSize, regularOutline } from '../typography/helpers';
import { darkRed, playGrey10 } from '../design-tokens';
import { device } from '../breakpoints';
import { Heading as BigImageHeading } from './components/Caption/Caption.styles';

export const cssBigImage = css`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    background: ${playGrey10};
    margin: 0 0 5px;

    @media ${device.GteXLarge} {
        margin: 0 0 7px;
    }
`;
export const StyledBigImage = styled.article`
    ${cssBigImage}
`;

export const StyledLiveBanner = styled.div`
    background: ${darkRed};
    color: ${regularWhite};
    text-align: center;
    width: 100%;
`;

export const StyledLiveBannerText = styled.p`
    text-transform: uppercase;
    letter-spacing: 0.4;
    ${playFontSize(1.6)};
    font-weight: ${fontWeightBold};
    padding: 5px;
`;

export const DisplayWindowLink = styled.a`
    display: block;
    position: relative;
    width: 100%;
    height: 100%;
    text-decoration: none;
    cursor: pointer;

    &:focus {
        ${regularOutline(2)}
    }

    &:active {
        outline: 0;
    }

    @media ${device.GteMedium} {
        display: flex;
        flex: 0 1 auto;
    }

    &:hover ${BigImageHeading} {
        text-decoration: underline;
    }
`;

export const imageContainerCss = css`
    width: 100%;

    @media ${device.GteMedium} {
        width: calc(((100% / 4) * 2) - 4px);

        .touchevents & {
            width: calc((100% / 1.4) - 15px);
        }
    }

    @media ${device.GteXLarge} {
        width: calc(((100% / 5) * 3) - 4px);
    }

    @media ${device.FullScreen} {
        width: calc(((100% / 6) * 4) - 4px);

        .touchevents & {
            width: 57.5%;
        }
    }
`;

export const ImageContainer = styled.div`
    ${imageContainerCss}
`;
